import * as Yup from 'yup'
export function insertvalidations(values) {
    return Yup.object().shape({
        priority: Yup.string().required('This field is required'),
        department_to: Yup.string().required('This field is required'),
        subject: Yup.string().required('This field is required'),
        message: Yup.string().required('This field is required'),
    });
}
